module.exports = fox._r("images/star_big.png", __webpack_public_path__ + "_/_/_/root/images/star_big.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/star_big.png
// module id = 403
// module chunks = 4